module.exports = __webpack_public_path__ + "static/img/6047_phase_function_Paper_Points.f69a885.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6047_phase_function_Paper_Points.png
// module id = 7Ylx
// module chunks = 0